export const hu = {
  meta: {
    title: 'Gyengeáramú rendszerek',
    description:
      'Tűzjelző, beléptető, behatolásjelző, CCTV és kaputelefon rendszerek tervezése, telepítése, karbantartása Budapesten és országosan. EN54, VdS, Grade 3 minősítés.',
    ogTitle: 'Tűzjelző rendszerek és biztonságtechnika | Archestor Kft.',
    ogDescription:
      'Professzionális gyengeáramú rendszerek: tűzjelző, beléptető, CCTV, behatolásjelző tervezése és kivitelezése európai szabványok szerint.',
    ogLocale: 'hu_HU'
  },
  nav: {
    home: 'Kezdőlap',
    about: 'Rólunk',
    services: 'Szolgáltatások',
    references: 'Referenciák',
    contact: 'Kapcsolat',
    menu: 'Menü',
    languageSelection: 'Nyelvválasztás',
    accessibilityMode: 'Látássérült üzemmód',
    accessibilityOn: 'Látássérült üzemmód bekapcsolva',
    accessibilityOff: 'Látássérült üzemmód kikapcsolva'
  },
  hero: {
    titleLine1: 'Biztonság,',
    titleLine2: 'amire',
    titleLine3: 'számíthat.',
    subtitle:
      'Komplex gyengeáramú rendszerek tervezése, telepítése és karbantartása európai szabványok szerint — egy kézben, egy felelősséggel.',
    cta: 'Kérjen árajánlatot',
    imageAlt: 'Gyengeáramú biztonságtechnikai rendszerek - tűzjelző és beléptető telepítés',
    stats: {
      projects: 'Sikeres projekt',
      standards: 'Európai szabvány',
      expertise: 'Rendszerismeret'
    }
  },
  about: {
    label: 'Rólunk',
    titleLine1: 'Magyar szakcég,',
    titleLine2: 'európai',
    titleLine3: 'mérce.',
    text1:
      'Magyarországon működő szakcég vagyunk, amely kizárólag gyengeáramú rendszerek tervezésével, telepítésével és karbantartásával foglalkozik.',
    text2:
      'Megbízható, intelligens és jövőbiztos rendszereket építünk irodaházakba, ipari létesítményekbe, kórházakba, közintézményekbe és lakóparkokba.',
    imageAlt: 'Ipari létesítmény gyengeáramú rendszerei - tűzjelző és CCTV'
  },
  services: {
    label: 'Szolgáltatások',
    titleLine1: 'Teljes körű',
    titleLine2: 'rendszerintegráció.',
    items: [
      {
        title: 'Tűzjelző rendszerek',
        desc: 'Címzett vagy konvencionális, egy- vagy többközpontos rendszerek EN54 és VdS szabványok szerint.'
      },
      {
        title: 'Beléptető rendszerek',
        desc: 'Kártyás, biometrikus és mobil beléptetés — forgóvillától rendszámfelismerős sorompóig.'
      },
      {
        title: 'Behatolásjelző',
        desc: 'Területvédelem, Grade 3 minősített rendszerek, akár 520 zónáig központonként.'
      },
      {
        title: 'CCTV megfigyelés',
        desc: 'HD és 4K IP kamerák, intelligens videóanalitika, távoli megfigyelés.'
      },
      {
        title: 'Gázveszélyjelző',
        desc: 'Robbanásveszélyes és mérgező gázok detektálása, integráció tűzjelző rendszerekkel.'
      },
      {
        title: 'Oltásvezérlő',
        desc: 'Gázzal és habbal oltó rendszerek vezérlése, tűzjelzővel integrálva.'
      },
      {
        title: 'Nővérhívó rendszer',
        desc: 'Kórházi, idősgondozói és mozgássérült mosdók teljes körű telepítése.'
      },
      {
        title: 'Kaputelefon rendszer',
        desc: 'Modern videós IP kaputelefonok, akár több lakásos kivitelben.'
      },
      {
        title: 'IT hálózatok',
        desc: 'Strukturált kábelezés, aktív hálózati eszközök, szerverhelyiségek kialakítása.'
      },
      {
        title: 'Szoftverfejlesztés',
        desc: 'Egyedi biztonsági rendszerek fejlesztése kiterjedt kapcsolati hálónkon keresztül.'
      },
      {
        title: 'Digitális naplózás',
        desc: 'Komplex digitális naplózórendszer tűzvédelmi és épületkarbantartási feladatokhoz.'
      },
      {
        title: 'Távfelügyelet',
        desc: 'Regisztrált telepítőként tűzjelző és behatolásjelző átjelző telepítése, vonulószolgálattal.'
      }
    ]
  },
  references: {
    label: 'Referenciák',
    titleLine1: 'Büszkék vagyunk',
    titleLine2: 'eddigi munkáinkra.',
    more: '...és még sok más sikeres projekt.',
    items: [
      {
        tag: 'Irodaház • Budapest (Budapart) • 2025-2026',
        title:
          'Modern irodakomplexum beléptető, behatolásjelző, nővérhívó és kaputelefon rendszer',
        desc: 'Büszkék vagyunk rá, hogy alvállalkozóként részt vehettünk egy kiemelt nagy beruházásban ahol beléptető, behatolásjelző, nővérhívó és kaputelefon rendszert telepítettünk 21 szinten keresztül.',
        alt: 'Budaparti irodaház - beléptető, behatolásjelző és kaputelefon rendszer'
      },
      {
        tag: 'Ipari • Szikszó • 2023-',
        title: 'Gyártóüzem és logisztikai épület komplex gyengeáramú rendszerei',
        desc: 'Tűzjelző, oltásvezérlő, gázveszélyjelző, beléptető, behatolásjelző, CCTV rendszer integrált telepítése és karbantartása alvállalkozóként.',
        alt: 'Szikszói ipari üzem - integrált tűzjelző, beléptető és CCTV rendszer'
      },
      {
        tag: 'Irodaház • Budapest (Angyalföld) • 2026',
        title: 'Irodaház fitout átépítés',
        desc: 'Tűzjelző rendszer fitout átépítése több szintet érintően partnerünk részére.',
        alt: 'Angyalföldi irodaház fitout - tűzjelző rendszer átépítés'
      },
      {
        tag: 'Logisztikai park • Polgár • 2025',
        title: 'Logisztikai park rendszámfelismerős beléptetés',
        desc: 'Automata rendszámfelismerős sorompórendszer kiépítése 0/24-es logolással, segélykérő kaputelefon rendszerrel.',
        alt: 'Polgári logisztikai park - rendszámfelismerős beléptetés és kaputelefon'
      },
      {
        tag: 'Irodaház • Budapest (Városliget) • 2025',
        title: '21.századi modern irodaház beléptető és behatolásjelző rendszer',
        desc: 'Partnerünk meghívására részt vettünk Budapest szívében lévő nagyszabású irodakomplexum biztonságtechnikai rendszereinek kivitelezésében és üzembehelyezésében.',
        alt: 'Városligeti irodaház - modern beléptető és behatolásjelző rendszer'
      },
      {
        tag: 'Társasház • Budapest (Zugló) • 2025',
        title: 'Társasház tűzjelző rendszer',
        desc: 'Tűzjelző rendszer üzembehelyezése.',
        alt: 'Zuglói társasház - tűzjelző rendszer kivitelezés'
      },
      {
        tag: 'Irodaház • Budapest • 2024',
        title: 'Irodaház rekonstrukció',
        desc: 'Tűzjelző rendszer rekonstrukciója, régi rendszerelemek integrálásával.',
        alt: 'Budapesti irodaház rekonstrukció - tűzjelző rendszer felújítás'
      },
      {
        tag: 'Irodaház • Budapest (Kelenföld) • 2024-2025',
        title: 'Irodaház fitout átépítés',
        desc: 'Tűzjelző, beléptető és kaputelefon rendszer fitout átépítése több szintet érintően alvállalkozóként partnerünk részére.',
        alt: 'Kelenföldi irodaház fitout - tűzjelző és beléptető rendszer'
      },
      {
        tag: 'Ipari • Debrecen • 2023-2025',
        title: 'Gyártókomplexum tűzjelző rendszer',
        desc: 'Alvállalkozóként részt vettünk az egyik legnagyobb régiós fejlesztésben, egy gyártókomplexum épületegyüttesének tűzjelző rendszeréhez kapcsolódó kivitelezésnek a felügyeletében és üzembehelyezésében.',
        alt: 'Debreceni gyártókomplexum - tűzjelző rendszer telepítés és felügyelet'
      }
    ]
  },
  contact: {
    label: 'Kapcsolat',
    titleLine1: 'Kezdjük el',
    titlePrefix: 'a ',
    titleEmphasis: 'közös munkát.',
    intro:
      'Ossza meg elképzeléseit — szakértőink rövid időn belül személyre szabott ajánlattal jelentkeznek.',
    emailLabel: 'Email',
    companyLabel: 'Cégadatok',
    companyName: 'Archestor Kft.',
    companyAddress: 'Székhely: Salgótarján, Arany János út 17.',
    companyReg: 'Cégjegyzékszám: 12-09-012726',
    companyTax: 'Adószám: 32403237-2-12',
    formSubject: 'Új árajánlat kérés - Archestor Kft.',
    namePlaceholder: 'Név *',
    companyPlaceholder: 'Cég',
    emailPlaceholder: 'Email cím *',
    messagePlaceholder: 'Projekt leírása…',
    submit: 'Küldés',
    success: 'Köszönjük! Hamarosan felvesszük Önnel a kapcsolatot.',
    captchaRequired: 'Kérjük, töltse ki a Captcha-t a küldéshez!',
    captchaFailed: 'Captcha ellenőrzés sikertelen.',
    captchaError: 'Hiba történt a captcha ellenőrzés során.',
    sendError: 'Hiba történt a küldés során.'
  },
  footer: {
    rights: 'Minden jog fenntartva.',
    cookieNotice: 'Adatkezelési tájékoztató',
    cookieSettings: 'Cookie beállítások'
  },
  renameNotice: {
    title: 'A cégnevünk megváltozott',
    body: 'A Fusion Safety Kft. új neve: Archestor Kft.\nCsak a nevünk változott, a cég adatai változatlanok maradtak, miként csapatunk is a megszokott magas minőségben folytatja a munkát.',
    close: 'Rendben'
  },
  cookies: {
    bannerTitle: 'Cookie-k és adatvédelem',
    bannerDescription:
      'A weboldal sütiket használ a működéshez, a kapcsolatfelvételi űrlap spamvédelméhez (Cloudflare Turnstile), valamint — az Ön hozzájárulásával — a nyelvi és kényelmi beállítások megjegyzéséhez. Bármikor módosíthatja a beállításokat.',
    acceptAll: 'Elfogadom',
    rejectAll: 'Nem fogadom el',
    contactFormBlocked:
      'A kapcsolatfelvételi űrlap a cookie-beállítások miatt nem érhető el. Az e-mail küldéshez fogadja el a sütiket.'
  },
  cookieNotice: {
    title: 'Adatkezelési tájékoztató',
    subtitle: 'Tájékoztató az archestor.com weboldal és aloldalain sütikkel összefüggő adatkezeléseiről',
    close: 'Bezárás',
    sections: [
      {
        title: '1. A süti fogalma és a használat célja',
        body: [
          'A sütik (cookie-k) kisméretű adatfájlok, amelyeket a meglátogatott weboldal szervere küld a felhasználó böngészőjébe, majd azok az eszközön tárolódnak.',
          'Az archestor.com weboldalon a sütik célja a weboldal biztonságos és kényelmes működtetése, a cookie-hozzájárulás rögzítése, a kapcsolatfelvételi űrlap spamvédelme, valamint — az Ön hozzájárulása esetén — a nyelvi és kényelmi beállítások megjegyzése.'
        ]
      },
      {
        title: '2. Sütik elfogadása vagy elutasítása',
        body: [
          'A weboldalon nem választhat külön-külön sütikategóriák közül: vagy az összes süti használatát elfogadja, vagy elutasítja.',
          'Elfogadás esetén a weboldal a működéshez, a nyelvi és kényelmi beállítások megjegyzéséhez, valamint a kapcsolatfelvételi űrlap spamvédelméhez (Cloudflare Turnstile) szükséges tárolókat használ.',
          'Elutasítás esetén nem helyezünk el sütiket, és a kapcsolatfelvételi űrlap nem érhető el.',
          'A weboldal nem alkalmaz statisztikai, hirdetési vagy marketing célú sütiket.'
        ]
      },
      {
        title: '3. Hozzájárulás kezelése',
        body: [
          'Az első látogatáskor cookie-ablak jelenik meg, amelyben elfogadhatja vagy elutasíthatja a sütik használatát. Elfogadás esetén a szükséges és funkcionális sütik aktiválódnak; elutasítás esetén a nem szükséges tárolók törlésre kerülnek, a kapcsolatfelvételi űrlap pedig nem érhető el.',
          'A hozzájárulást bármikor módosíthatja a láblécben található „Cookie beállítások” gombbal. A korábban megadott hozzájárulás visszavonható az elutasítás választásával.'
        ]
      },
      {
        title: '4. A sütik beállítása a böngészőben',
        body: [
          'A sütik kezelése a böngésző beállításaiban is szabályozható. A böngészőben letilthatja vagy törölheti a sütiket; ez azonban befolyásolhatja a weboldal egyes funkcióinak használhatóságát.'
        ]
      }
    ],
    tableTitle: '5. Az egyes sütik jellemzői',
    tableHeaders: {
      name: 'Név',
      function: 'Funkció',
      type: 'Típus',
      duration: 'Időtartam',
      purpose: 'Cél',
      legalBasis: 'Jogalap'
    },
    rows: [
      {
        name: 'archestor-consent',
        function: 'Cookie-hozzájárulás rögzítése',
        type: 'HTTP süti',
        duration: '1 év',
        purpose: 'A felhasználó cookie-választásának tárolása',
        legalBasis: 'Jogos érdek / hozzájárulás'
      },
      {
        name: 'archestor-locale',
        function: 'Nyelvi beállítás',
        type: 'HTTP süti',
        duration: '1 év',
        purpose: 'A kiválasztott nyelv megjegyzése',
        legalBasis: 'Hozzájárulás'
      },
      {
        name: 'archestor-country',
        function: 'Országkód tárolása',
        type: 'HTTP süti',
        duration: '24 óra',
        purpose: 'Ország-alapú nyelvi ajánlás támogatása',
        legalBasis: 'Hozzájárulás'
      },
      {
        name: 'archestor-a11y',
        function: 'Akadálymentes üzemmód',
        type: 'Helyi tároló (localStorage)',
        duration: 'Törlésig',
        purpose: 'Látássérült üzemmód beállításának megjegyzése',
        legalBasis: 'Hozzájárulás'
      },
      {
        name: 'archestor-rename-seen',
        function: 'Cégnévváltozás tájékoztató',
        type: 'Helyi tároló (localStorage)',
        duration: 'Törlésig',
        purpose: 'Annak megjegyzése, hogy a látogató a Fusion Safety névváltozásáról szóló tájékoztatót már bezárta',
        legalBasis: 'Jogos érdek'
      },
      {
        name: 'Cloudflare Turnstile',
        function: 'Spamvédelem',
        type: 'Harmadik fél (HTTP süti)',
        duration: 'A szolgáltató dokumentációja szerint',
        purpose: 'Kapcsolatfelvételi űrlap robotok elleni védelme',
        legalBasis: 'Hozzájárulás'
      },
      {
        name: 'FormSubmit',
        function: 'E-mail továbbítás',
        type: 'Harmadik fél (HTTP süti)',
        duration: 'A szolgáltató dokumentációja szerint',
        purpose: 'Kapcsolatfelvételi üzenetek kézbesítése',
        legalBasis: 'Hozzájárulás'
      }
    ],
    thirdPartyTitle: '6. Harmadik fél sütikezelése és adatvédelem',
    thirdPartyServices: [
      {
        description:
          'A kapcsolatfelvételi űrlap spamvédelméhez Cloudflare Turnstile szolgáltatást használunk. A Turnstile csak cookie-elfogadás után töltődik be, és a Cloudflare saját adatvédelmi szabályzata szerint működik.',
        privacyLabel: 'A Cloudflare adatvédelmi tájékoztatója:',
        privacyUrl: 'https://www.cloudflare.com/privacypolicy/'
      },
      {
        description:
          'A kapcsolatfelvételi űrlap üzeneteinek továbbításához FormSubmit (formsubmit.co) szolgáltatást használunk. Az e-mail küldés csak cookie-elfogadás után lehetséges; a beküldött adatok a FormSubmit rendszerén keresztül jutnak el hozzánk.',
        privacyLabel: 'A FormSubmit adatvédelmi tájékoztatója:',
        privacyUrl: 'https://formsubmit.co/privacy.pdf',
        openInNewTab: false
      },
      {
        description:
          'A beérkező kapcsolatfelvételi e-mailek a Archestor Kft. Microsoft 365 (Outlook) postafiókjába érkeznek. Az e-mail szolgáltatást a Microsoft biztosítja, saját adatvédelmi szabályzata szerint.',
        privacyLabel: 'A Microsoft adatvédelmi tájékoztatója:',
        privacyUrl: 'https://privacy.microsoft.com/'
      }
    ],
    operatorTitle: '7. A weboldal üzemeltetője',
    operatorBody: [
      'Archestor Kft.',
      'Székhely: Salgótarján, Arany János út 17.',
      'Cégjegyzékszám: 12-09-012726',
      'E-mail: office@archestor.com'
    ],
    hostingTitle: '8. A tárhelyszolgáltató',
    hostingBody: [
      'Cloudflare, Inc.',
      'Székhely: 101 Townsend Street, San Francisco, CA 94107, USA',
      'Web: https://www.cloudflare.com/',
      'E-mail: privacy@cloudflare.com',
      'A weboldal a Cloudflare edge hálózatán keresztül működik. EU-s látogatók esetén a tartalom EU adatközpontokban, európai szervereken kerül kiszolgálásra; EU-n kívüli látogatók esetén a hozzá legközelebbi edge kiszolgálóról.'
    ],
    contactTitle: '9. Kapcsolat és érintetti jogok',
    contactBody: [
      'A sütikkel és adatkezeléssel kapcsolatos kérdésekkel az office@archestor.com címen fordulhat hozzánk.',
      'Ön tiltakozhat a jogos érdeken alapuló adatkezelés ellen, és kérheti adatai törlését.'
    ]
  },
  toast: {
    emailSuccess: 'Sikeres email küldés! Hamarosan jelentkezünk!'
  },
  schema: {
    description:
      'Magyarországon működő szakcég gyengeáramú rendszerek (tűzjelző, beléptető, CCTV, behatolásjelző) tervezésével, telepítésével és karbantartásával.',
    addressLocality: 'Salgótarján',
    catalogName: 'Biztonságtechnikai szolgáltatások',
    areaServed: [
      { type: 'Country', name: 'Magyarország' },
      { type: 'City', name: 'Budapest' }
    ],
    services: [
      {
        name: 'Tűzjelző rendszerek',
        description: 'EN54 és VdS szabványú tűzjelző rendszerek tervezése és telepítése.'
      },
      {
        name: 'Beléptető rendszerek',
        description: 'Kártyás, biometrikus és rendszámfelismerős beléptetés.'
      },
      {
        name: 'CCTV és behatolásjelző',
        description: 'HD/4K kamerarendszerek és Grade 3 behatolásjelző.'
      }
    ]
  }
} as const

export type Messages = typeof hu